function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useState, useEffect, useRef } from 'react';
import { classnames, formatDate, parseDate } from '@bydesign-ui/utils';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { useCombineCallback, useRefCallback, useRefGetter } from '@bydesign-ui/hooks';
import { Button } from '../button';
import { TimePanel } from '../time-panel';
import { DatePanel } from '../date-panel';
import { Time } from '../../units/date/layout/Time';
export function DateTimePanel(props) {
  var locale = useLocale('date');
  var dateTimePickerOk = useLocale('date-time-picker.ok');

  var defaultTime = props.defaultTime,
      showHour = props.showHour,
      showMinute = props.showMinute,
      showSecond = props.showSecond,
      hourStep = props.hourStep,
      minuteStep = props.minuteStep,
      secondStep = props.secondStep,
      disabledHours = props.disabledHours,
      disabledMinutes = props.disabledMinutes,
      disabledSeconds = props.disabledSeconds,
      defaultDate = props.defaultDate,
      presets = props.presets,
      outRangeDisabled = props.outRangeDisabled,
      needRangeValid = props.needRangeValid,
      isDateDisabled = props.isDateDisabled,
      isMonthDisabled = props.isMonthDisabled,
      isYearDisabled = props.isYearDisabled,
      disabled = props.disabled,
      _props$startDay = props.startDay,
      startDay = _props$startDay === void 0 ? locale.startDay : _props$startDay,
      value = props.value,
      format = props.format,
      onChange = props.onChange,
      onValueChange = props.onValueChange,
      onConfirm = props.onConfirm,
      className = props.className,
      extra = _objectWithoutProperties(props, ["defaultTime", "showHour", "showMinute", "showSecond", "hourStep", "minuteStep", "secondStep", "disabledHours", "disabledMinutes", "disabledSeconds", "defaultDate", "presets", "outRangeDisabled", "needRangeValid", "isDateDisabled", "isMonthDisabled", "isYearDisabled", "disabled", "startDay", "value", "format", "onChange", "onValueChange", "onConfirm", "className"]);

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      userValue = _useState2[0],
      setUserValue = _useState2[1];

  var canDefaultValueUsedRef = useRef(!value);
  var onConfirmCallback = useRefCallback(onConfirm);
  var formatGetter = useRefGetter(format == null ? locale.defaultFormat.dateTime : format);
  var userDate = parseDate(userValue, formatGetter(), locale);
  var onChangeCallback = useCombineCallback(onChange, onValueChange);
  var dateTimeCls = classnames(usePrefixCls('date-time'), className);
  var dateTimeFooterCls = usePrefixCls('date-time-footer');
  var dateTimeContentCls = usePrefixCls('date-time-content');
  var dateTimeWrapperCls = usePrefixCls('date-time-wrap');
  var dateTimeHeadCls = usePrefixCls('date-time-head');
  useEffect(function () {
    if (value.match(/^\s*$/)) {
      canDefaultValueUsedRef.current = true;
      setUserValue('');
    } else {
      canDefaultValueUsedRef.current = false;
    }
  }, [value]);

  var isNumber = function isNumber(param) {
    return typeof param === 'number' && !Number.isNaN(param);
  };

  var onDateTimeChange = useCallback(function (dateTime, type) {
    var newDate = parseDate(dateTime, formatGetter(), locale);
    var canDefaultValueUsed = canDefaultValueUsedRef.current;

    if (type === 'date' && !canDefaultValueUsed) {
      var oldDate = parseDate(userValue, formatGetter(), locale);

      var _hours = oldDate.getHours();

      var _minutes = oldDate.getMinutes();

      var _seconds = oldDate.getSeconds();

      isNumber(_hours) && newDate.setHours(_hours);
      isNumber(_minutes) && newDate.setMinutes(_minutes);
      isNumber(_seconds) && newDate.setSeconds(_seconds);
    }

    if (type === 'date' && defaultTime && canDefaultValueUsed) {
      var _defaultTime$split = defaultTime.split(':'),
          _defaultTime$split2 = _slicedToArray(_defaultTime$split, 3),
          _hh = _defaultTime$split2[0],
          _mm = _defaultTime$split2[1],
          _ss = _defaultTime$split2[2];

      isNumber(+_hh) && newDate.setHours(+_hh);
      isNumber(+_mm) && newDate.setMinutes(+_mm);
      isNumber(+_ss) && newDate.setSeconds(+_ss);
    } else if (type === 'time' && defaultDate && canDefaultValueUsed) {
      var _defaultDate = defaultDate instanceof Date ? defaultDate : new Date(defaultDate);

      var _year = _defaultDate.getFullYear();

      var _month = _defaultDate.getMonth();

      var _day = _defaultDate.getDate();

      isNumber(_year) && newDate.setFullYear(_year);
      isNumber(_month) && newDate.setMonth(_month);
      isNumber(_day) && newDate.setDate(_day);
    }

    var newDateTime = formatDate(newDate, formatGetter(), locale);
    onChangeCallback(newDateTime);
    setUserValue(newDateTime);
  }, [userValue, setUserValue]);
  return React.createElement("div", Object.assign({
    className: dateTimeCls
  }, extra), React.createElement("div", {
    className: dateTimeContentCls
  }, React.createElement(DatePanel, {
    value: userValue,
    onChange: function onChange(val) {
      return onDateTimeChange(val, 'date');
    },
    format: format || locale.defaultFormat.dateTime,
    presets: presets,
    outRangeDisabled: outRangeDisabled,
    needRangeValid: needRangeValid,
    isDateDisabled: isDateDisabled,
    isMonthDisabled: isMonthDisabled,
    isYearDisabled: isYearDisabled,
    disabled: disabled,
    startDay: startDay
  }), React.createElement("div", {
    className: dateTimeWrapperCls
  }, React.createElement("div", {
    className: dateTimeHeadCls
  }, userDate && React.createElement(Time, {
    date: userDate
  })), React.createElement(TimePanel, {
    value: userValue,
    onChange: function onChange(val) {
      return onDateTimeChange(val, 'time');
    },
    format: format || locale.defaultFormat.dateTime,
    hourStep: hourStep,
    minuteStep: minuteStep,
    secondStep: secondStep,
    showHour: showHour,
    showMinute: showMinute,
    showSecond: showSecond,
    disabledHours: disabledHours,
    disabledMinutes: disabledMinutes,
    disabledSeconds: disabledSeconds
  }))), React.createElement("div", {
    className: dateTimeFooterCls
  }, React.createElement("div", null, React.createElement(Button, {
    size: "xs",
    type: "primary",
    onClick: onConfirmCallback,
    disabled: !userValue
  }, dateTimePickerOk))));
}